import { trackFrameGiftCarousel } from '@src/utils/frameGiftAnalytics';
import { PersonalGiftCheckout } from '../PersonalGiftCheckout';
import { BellIcon } from '@src/components/icons/BellIcon';
import { UserIcon } from '@src/components/icons/UserIcon';
import { GiftHelpPreview } from './GiftHelpPreview';
import { pushDialog } from '@src/components/Dialog/Dialog';
import { isDotCom } from '@src/site';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GiftIcon, Link, TextFieldWithPresets, Typography } from '@src/components';
import type { FullCardInfo } from '@lub0v/santa-utils';
import { AvatarFramePicker } from '@src/components/faces/AvatarFramePicker';
import './GifteeFramePreview.css';

export function GifteeFramePreview({ ward, boxKey, flowId, initialMessage = '', initialEmail, paymentFailed = false }: { ward: FullCardInfo; boxKey?: string; flowId?: string; initialMessage?: string; initialEmail?: string; paymentFailed?: boolean }) {
  const { t } = useTranslation();
  const [message, setMessage] = useState(initialMessage);
  const presets = ['warmth', 'smile', 'magic', 'santa'] as const;
  const [selectedFrame, setSelectedFrame] = useState(ward.frameName || 'frame_2');
  const showGiftHelp = () => pushDialog({
    title: t('game.ward.frameHelpTitle'),
    testId: 'giftee-frame-help-dialog',
    mobileFullScreen: true,
    submit: t('game.ward.frameHelpClose'),
    children: <div className="giftee-frame-preview__help-copy">
      <Typography as="p" role="body/sm">{t('game.ward.frameHelpIntro')}</Typography>
      <GiftHelpPreview />
      <ol className="giftee-frame-preview__steps">
        {[{ key: 'Notification', icon: <BellIcon /> }, { key: 'Open', icon: <GiftIcon /> }, { key: 'Apply', icon: <UserIcon /> }].map(({ key, icon }, index) =>
          <li key={key}>
            <span className="giftee-frame-preview__step-icon" aria-hidden="true">{icon}</span>
            <div><Typography as="p" role="body/base"><strong>{index + 1}. {t('game.ward.frameHelp' + key + 'Title')}</strong></Typography>
              <Typography as="p" role="body/sm">{t('game.ward.frameHelp' + key)}</Typography></div>
          </li>)}
      </ol>
      <div className="giftee-frame-preview__help-note">
        {!isDotCom() && <Typography as="p" role="body/sm">✨ {t('game.ward.frameHelpAds')}</Typography>}
        <Typography as="p" role="body/sm">{t('game.ward.frameHelpMessage')}</Typography>
      </div>
    </div>,
  });
  return <div className="giftee-frame-preview" data-testid="giftee-frame-content">
    <PersonalGiftCheckout flowId={flowId} boxKey={boxKey} wardId={ward.id} message={message} initialEmail={initialEmail} paymentFailed={paymentFailed}>
    {offer => <>
    <div className="giftee-frame-preview__intro">
      <Typography as="p" role="body/sm">{t(isDotCom() ? 'game.ward.framePreviewIntroCom' : 'game.ward.framePreviewIntro')}</Typography>
      <Link variant="quiet" onClick={showGiftHelp} testId="giftee-frame-help">{t('game.ward.frameHelpLink')}</Link>
    </div>
    <AvatarFramePicker cropped card={ward} selectedFrame={selectedFrame} onChange={frame => { setSelectedFrame(frame); trackFrameGiftCarousel(offer); }} testIdPrefix="giftee-frame" />
    <TextFieldWithPresets
      heading={t('game.ward.frameMessageHeading')}
      presets={presets.map(preset => t('game.ward.frameMessages.' + preset))}
      presetsLabel={t('game.ward.frameMessagePresets')}
      label={t('game.ward.frameMessageLabel')}
      placeholder={t('game.ward.frameMessagePlaceholder')}
      value={message} onValueChange={setMessage}
      rows={2} maxLength={140} showCount testId="giftee-frame-message"
    />
    </>}
    </PersonalGiftCheckout>
  </div>;
}
